<!-- <p>address works!</p> -->
<h3 class="ind_head">Addrress</h3>
<!-- <h5 class="smallheader">Address</h5>
<div class="address_display_cont">
	<div class="inner_address">
		<div class="head">Billing Address:</div>
		<div class="body">
			Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit quia placeat iure sed animi, dicta ducimus a aliquid porro voluptates perferendis nobis eligendi maxime dolore vel nostrum sequi minus! Totam!
		</div>
	</div>
	<div class="inner_address">
		<div class="head">Shipping Address:</div>
		<div class="body">
			Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit quia placeat iure sed animi, dicta ducimus a aliquid porro voluptates perferendis nobis eligendi maxime dolore vel nostrum sequi minus! Totam!
		</div>
	</div>
</div> -->
<fb-address-comp></fb-address-comp>
